import { render, staticRenderFns } from "./ArchiveEstimates.vue?vue&type=template&id=1e08cd56&"
import script from "./ArchiveEstimates.vue?vue&type=script&lang=js&"
export * from "./ArchiveEstimates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveEstimates.vue"
export default component.exports